import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../../basic-ui-components/icon/svg-icon/svg.icon';

export interface IJackpotsIconProps extends ISvgIconProps {

}

export class JackpotsIcon extends React.Component<IJackpotsIconProps> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <g>
                    <path d="M13.021 4.896A1.02 1.02 0 1 1 12 3.876a1.02 1.02 0 0 1 1.021 1.02z" fill="currentColor"/>
                    <path d="M3.636 6.766a1.02 1.02 0 1 1-1.02-1.02 1.02 1.02 0 0 1 1.02 1.02z" fill="currentColor"/>
                    <path d="M20.365 6.766a1.02 1.02 0 1 0 1.02-1.02 1.02 1.02 0 0 0-1.02 1.02z" fill="currentColor"/>
                    <path d="M12.001 7.287 4.823 17.23c0-.174-1.358-8.478-1.358-8.478l8.536 8.478" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
                    <path d="m12.001 7.287 7.178 9.943c0-.174 1.358-8.478 1.358-8.478l-8.536 8.478" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
                    <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M19.178 19.374H4.822"/>
                </g>
            </SvgIcon>
        );
    }
}
